var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VendorForm',{attrs:{"vendor":_vm.vendor,"buttonLoading":_vm.buttonLoading},on:{"saveVendor":_vm.saveVendor}})
}
var staticRenderFns = []

export { render, staticRenderFns }